<template>
  <el-dialog :title="editFormTitle" :visible.sync="visible" width="600px" center>
    <el-form :model="editForm">
      <el-form-item label="护工姓名" :label-width="formLabelWidth">
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="护工手机号" :label-width="formLabelWidth">
        <el-input v-model="editForm.tel" autocomplete="off" />
      </el-form-item>
      <el-form-item label="区域" :label-width="formLabelWidth">
        <el-select class='w100' v-model="editForm.region" placeholder="请选择">
          <el-option v-for="(address, index) in regionList.filter(i => i !== '全部') " :key="index" :label="address" :value="address"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="editForm.region === '潜山市'" label="服务地点" :label-width="formLabelWidth">
        <el-select class='w100' v-model="editForm.address" placeholder="请选择服务地点">
          <el-option label="请选择..." value=""></el-option>
          <el-option v-for="(address, index) in nurseList " :key="index" :label="address.name" :value="address.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isEmpty } from '@/utils'
import { addNurse, editNurse, fetchNurseAddressList } from '../../../api'

export default {
  name: 'EditNurse',
  data() {
    return {
      id: null,
      editForm: {
        name: '',
        tel: '',
        address: ''
      },
      formLabelWidth: '153px',
      nurseList: [],
      regionList: [],
      regionData: '',
      visible: false
    }
  },
  computed: {
    editFormTitle() {
      return isEmpty(this.id) ? '护士详情' : '新增护士'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const rulesData = this.$store.state.rules.filter(i => i.url === '/nurse-management')[0]
      this.regionList = Object.values(rulesData.child).map(mapData => {
        return mapData.name
      })
    },
    async handleOpen(val) {
      let defaultFrom = {
        name: '',
        tel: '',
        address: ''
      }
      this.getNurseAddressList()
      this.id = null
      if (!isEmpty(val)) {
        defaultFrom = {
          ...val
        }
        this.id = val.id
      }
      this.editForm = defaultFrom
      this.visible = true
    },
    getNurseAddressList() {
      fetchNurseAddressList().then(res =>  {
        if (res.status) {
          this.nurseList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleSubmit() {
      const { id, } = this
      const { name, tel, address, status, region } = this.editForm
      let c = addNurse

      if (isEmpty(name)) return this.$message({ message: '请输入护工姓名！', type: 'warning' })
      if (isEmpty(tel)) return this.$message({ message: '请输入护工手机号！', type: 'warning' })
      if (isEmpty(address) && region === '潜山市') return this.$message({ message: '请选择服务地点！', type: 'warning' })

      const params = {
        name, tel, address, region: region
      }

      if (id) {
        params.id = id
        params.status = status
        c = editNurse
      }
      c(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.handleClose()
          this.$emit('update')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose() {
      this.visible = false
    },
  }
}
</script>

<style scoped>

</style>
